export const formatMoney = (value, currency) => {
	const amount = Number(value || 0);
	const formatted = amount.toLocaleString(undefined, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
	return currency ? `${currency} ${formatted}` : formatted;
};

export const normalizePhoneForApi = (value) => String(value || '').replace(/[\s-]/g, '');

export const getResponseMessage = (response, fallback = 'Something went wrong. Please try again.') =>
	response?.message || fallback;
